import React, { useEffect, useRef, useState } from 'react';
import { userAuth } from '../../../network/apis/apiUri';
import useAxios from '../../../network/useAxios';

export default function GoogleAuth({ nickNameValue, memberRadio, setLoginModal }) {
  const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENTID;
  const googleRef = useRef();

  const [tokenId, setTokenId] = useState(null);

  const [loginItem, loginRefetch] = useAxios(userAuth, [], {}, false);
  const { data: loginData, error: loginErr } = loginItem;

  useEffect(() => {
    window.google.accounts.id.initialize({
      client_id: CLIENT_ID,
      callback: (data) => setTokenId(data.credential),
      ux_mode: 'popup',
    });

    window.google.accounts.id.renderButton(googleRef.current, {
      theme: 'outline',
      size: 'large',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tokenId) {
      if (memberRadio === 0) {
        loginRefetch({ action_type: 'both', auth_type: 'google', token: tokenId, nick_name: nickNameValue });
      } else {
        loginRefetch({ action_type: 'login', auth_type: 'google', token: tokenId });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenId, nickNameValue, memberRadio]);

  useEffect(() => {
    if (loginData) {
      if (loginData?.resultCode?.http_status === 200) {
        localStorage.setItem(
          'userData',
          JSON.stringify({
            token: loginData.resultCode.access_token,
            nickName: loginData.nick_name,
          })
        );
        setLoginModal(false);
      }
    }
    if (loginErr) {
      if (loginErr?.response.data.resultCode.message === 'ayp ot est (4)') {
        alert('중복된 닉네임 입니다.');
        return;
      } else {
        alert('로그인에 실패하였습니다.');
        return;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginItem]);

  return <div ref={googleRef}></div>;
}
